<style scoped>
.status {
    display: inline-block;
    border-left: 5px solid rgba(0, 0, 0, 0);
    padding-left: 3px;
}
.override {
    background: black;
    color: #ccc;
}
</style>
<template>
    <span class="status" :style="{ 'border-left-color': borderColor }">
        <div class="override" v-if="overrideText">({{ overrideText }})</div>
        {{ displayText }}

        <!--
        {{ displayData }} {{ status }} {{ statusChanging ? "Y" : "N" }} {{ status != null ? status.pendingSet?"Y":"N" : "X" }} {{ status != null ? (status.pending != status.current)?"Y":"N" : "X" }}
        -->
        <template v-if="statusChanging">
            <LoadingWheel style="display: inline-block; vertical-align: text-bottom" :width="16" />
        </template>
        <template v-if="status.saveStatus != null && status.saveStatus == 'failed'"> Save Failed! </template>
        <template v-if="status.saveErrors != null && status.saveErrors.length > 0">
            <ul>
                <li v-for="error in status.saveErrors">{{ error }}</li>
            </ul>
        </template>
    </span>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
//TODO duplicate with Status.vue
interface FeatureFlagState {
    current?: boolean | null;
    pending?: boolean | null;
    pendingSet?: boolean | null;
    saveStatus?: string | null;
    saveErrors?: string[];
}
interface Props {
    status: FeatureFlagState;
    override?: boolean;
    global?: boolean;
}
export default defineComponent({
    components: {
        LoadingWheel,
    },
    props: ["status", "override", "global"],
    setup(props: Props) {
        const statusChanging = computed(() => {
            return props.status != null && props.status.pending != props.status.current && props.status.pendingSet;
        });
        const displayText = computed(() => {
            return displayData.value.text;
        });
        const overrideText = computed(() => {
            return displayData.value.overrideText;
        });
        const borderColor = computed(() => {
            return displayData.value.borderColor;
        });
        const displayData = computed(() => {
            let result = {} as { borderColor?: string; text?: string; overrideText?: string };
            if (props.status == null) {
                return result;
            }
            switch (props.override ?? props.status.current) {
                case true:
                    result.borderColor = "#00b300";
                    break;
                case false:
                    result.borderColor = "#595959";
                    break;
                case null:
                case undefined:
                    result.borderColor = "#cfcfcf";
                    break;
                default:
                    throw new Error(props.status.current?.toString());
            }
            switch (props.status.current) {
                case true:
                    result.text = "Enabled";
                    break;
                case false:
                    result.text = "Off";
                    break;
                case null:
                case undefined:
                    result.text = "Unset";
                    break;
                default:
                    throw new Error(props.status.current);
            }
            switch (props.override) {
                case true:
                    result.overrideText = "Enabled";
                    break;
                case false:
                    result.overrideText = "Off";
                    break;
                case null:
                case undefined:
                    // Don't show
                    break;
                default:
                    throw new Error(props.override);
            }
            if (statusChanging.value) {
                switch (props.status.pending) {
                    case true:
                        result.text = "Enabling";
                        break;
                    case false:
                        result.text = "Disabling";
                        break;
                    case null:
                        result.text = "Unsetting";
                        break;
                }
            }
            return result;
        });

        return {
            borderColor,
            overrideText,
            displayText,
            statusChanging,
        };
    },
});
</script>
